import { OTPVia } from '../configs/authSignupConfig';
import * as serviceContext from '../services/serviceContext';
import qs from 'qs';
var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function signin(userData,loginwithdemo) {
    try {
        const response = await (loginwithdemo ? serviceContext.get("sso/auth/demo", null, options) : serviceContext.post("sso/auth", qs.stringify(userData), options));
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function velidateToken() {
    try {
        const response = await serviceContext.get("sso/auth", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function setPassword(data) {
    try {
        const response = await serviceContext.post("manage/profile/changepassword", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function changePassword(data) {
    try {
        const response = await serviceContext.post("manage/profile/changepassword", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getProfile(uid) {
    try {
        const response = await serviceContext.get("manage/users/detail/"+uid, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getConfigButton() {
    try {
        const response = await serviceContext.get("manage/profile/buttons", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postConfigButton(data) {
    
    try {
        const response = await serviceContext.post("manage/profile/buttons", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


// manage/signup/checkusername/{username} get request for check username
export async function Register(userData) {
    try {
        const response = await serviceContext.post("online/signup", JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function RegisterNewWithOtp(userData) {
    try {
        const response = await serviceContext.post("online/SignUp", JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function checkIfUserExists(username) {
    try {
        const response = await serviceContext.get(`online/Check/user/${username}`, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function checkIfMobileExists(mobile) {
    try {
        const response = await serviceContext.get(`online/Check/mobile/${mobile}`, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function forgetPassword(userData) {
    try {
        let urll = OTPVia === 'mobile' ? `online/ForgetPassword` : `online/forgetpassword/bymail`
        const response = await serviceContext.post(urll, JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function sendOTP(data) {
    try {
        let urll = OTPVia === 'mobile' ? `online/Check/sendotp` : `online/check/sendotp/bymail`;
        const response = await serviceContext.post(urll, JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCaptcha() {
    try {
        const response = await serviceContext.get("sso/auth/requestcaptcha", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};